import React from 'react';
import './EngineeringConsultation.css';

const EngineeringConsultation = () => {
  const services = [
    {
      id: 1,
      title: "Design and Engineering Services",
      items: [
        { title: "Structural Design", description: "Providing structural engineering solutions and ensuring safety compliance." },
        { title: "Mechanical Engineering", description: "Creating specifications and designs for mechanical systems." },
        { title: "Electrical Engineering", description: "Designing electrical systems, power distribution, and load analysis." },
        { title: "Civil Engineering", description: "Covering infrastructure design, including roadways, drainage, and earthworks." }
      ]
    },
    {
      id: 2,
      title: "Computational Fluid Dynamics (CFD) Services",
      items: [
        { title: "Fluid Flow Analysis", description: "Detailed CFD modeling of fluid flows within systems." },
        { title: "Thermal Analysis", description: "Simulating heat transfer in fluids and solids." },
        { title: "Multiphase Flow Analysis", description: "Modeling of systems with gas-liquid or solid-liquid interactions." },
        { title: "Aerodynamic Simulation", description: "Evaluation of flow dynamics around surfaces." },
        { title: "Flow-Induced Vibration Analysis", description: "Assessing fluid flow impact on structures." },
        { title: "Design Optimization", description: "Utilizing CFD data to optimize component design." }
      ]
    },
    {
      id: 3,
      title: "Finite Element Analysis (FEA) Services",
      items: [
        { title: "Structural Analysis and Stress Testing", description: "FEA-based structural simulations for stress, strain, and deformation analysis." },
        { title: "Thermal Stress Analysis", description: "Modeling thermal stresses to prevent temperature-related failures." },
        { title: "Fatigue and Fracture Analysis", description: "Predicting component fatigue life under cyclic loading." },
        { title: "Vibration and Dynamic Analysis", description: "Analyzing mode shapes and frequency response." },
        { title: "Nonlinear Material Analysis", description: "Examining non-linear stress-strain relationships." },
        { title: "Failure Mode Analysis", description: "Identifying potential failure points and improvements." },
        { title: "Optimization of Component Geometry", description: "Optimizing for strength, weight, and cost efficiency." }
      ]
    },
    {
      id: 4,
      title: "Pipe Stress Analysis Services",
      items: [
        { title: "Static and Dynamic Pipe Stress Analysis", description: "Assessing static and dynamic loads on piping systems." },
        { title: "Thermal Expansion Analysis", description: "Ensuring systems handle thermal expansion safely." },
        { title: "Fatigue and Creep Analysis", description: "Evaluating long-term cyclic loading effects." },
        { title: "Load Condition Simulation", description: "Verifying compliance with industry standards." },
        { title: "Support and Anchor Point Design", description: "Optimizing support locations." },
        { title: "Flexibility and Stress Optimization", description: "Maximizing system flexibility." }
      ]
    },
    {
      id: 5,
      title: "Hydraulic Calculation and System Design",
      items: [
        { title: "Pipeline Hydraulic Design", description: "Calculating optimal pipe sizes and flows." },
        { title: "Pump and Valve Selection", description: "Designing based on flow rates and efficiency." },
        { title: "Pressure Drop Calculations", description: "Estimating system pressure drops." },
        { title: "Hydraulic Network Analysis", description: "Optimizing flow distribution." },
        { title: "Transient and Surge Analysis", description: "Managing pressure surges." },
        { title: "Flow and Level Control Design", description: "Engineering control systems." },
        { title: "System Troubleshooting", description: "Identifying and resolving inefficiencies." }
      ]
    },
    {
      id: 6,
      title: "Design Optimization and Validation",
      items: [
        { title: "3D Modeling and Simulation", description: "Using advanced software for design optimization." },
        { title: "Prototyping and Testing", description: "Validating designs through scaled testing." },
        { title: "Performance Validation", description: "Supporting certification and standards compliance." }
      ]
    },
    {
      id: 7,
      title: "Construction Support and Site Supervision",
      items: [
        { title: "On-Site Supervision", description: "Direct oversight to ensure adherence to engineering plans and safety." },
        { title: "Construction Phase Consulting", description: "Addressing issues during construction and providing technical expertise." },
        { title: "Field Testing & Reporting", description: "Conducting material and soil testing on-site for quality assurance." }
      ]
    },
    {
      id: 8,
      title: "Quality Assurance and Compliance",
      items: [
        { title: "Regulatory Compliance Consulting", description: "Ensuring designs and plans meet local, state, and federal regulations." },
        { title: "Safety Assessments", description: "Identifying and mitigating potential safety issues." },
        { title: "Quality Control", description: "Setting and maintaining quality standards throughout the project." }
      ]
    },
    {
      id: 9,
      title: "Sustainability and Green Building Consulting",
      items: [
        { title: "Energy Efficiency Analysis", description: "Recommending sustainable energy sources and efficient designs." },
        { title: "Waste Minimization", description: "Developing plans to minimize environmental impact during construction and operation." }
      ]
    },
    {
      id: 10,
      title: "Feasibility Studies",
      items: [
        { title: "Project Viability Assessment", description: "Analysing potential challenges, benefits, and risks." },
        { title: "Site Analysis", description: "Determining location suitability for intended projects." },
        { title: "Cost-Benefit Analysis", description: "Evaluating financial feasibility and ROI estimates." },
        { title: "Environmental Impact Assessment", description: "Checking compliance with environmental regulations." }
      ]
    },
    {
      id: 11,
      title: "Documentation",
      items: [
        { title: "Comprehensive Documentation", description: "Creating detailed guides, manuals, and documentation for project continuity." },
        { title: "Technical Writing", description: "Preparing clear and detailed technical documentation." },
        { title: "As-Built Documentation", description: "Maintaining accurate records of completed work." }
      ]
    },
    {
      id: 12,
      title: "Project Management and Planning",
      items: [
        { title: "Project Scheduling", description: "Development of timelines and project milestones." },
        { title: "Budgeting & Cost Estimation", description: "Accurate financial planning, including material, labor, and equipment costs." },
        { title: "Resource Allocation", description: "Strategically assigning resources for efficiency and productivity." },
        { title: "Risk Management", description: "Identifying and planning for potential risks in the project lifecycle." }
      ]
    },
    {
      id: 13,
      title: "Technology and Innovation",
      items: [
        { title: "BIM (Building Information Modeling)", description: "Offering expertise in BIM for project visualization and management." },
        { title: "Automation and Smart Systems Design", description: "Integrating IoT, automation, and smart technology into projects." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Engineering Consultation</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Engineering Services Section */}
      <div className="bim-services">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default EngineeringConsultation;